export default {
  badge: 'Odznak',
  open: 'Otvoriť',
  close: 'Zavrieť',
  dismiss: 'Zrušiť',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Zrušiť',
  },
  dataIterator: {
    noResultsText: 'Neboli nájdené žiadne záznamy',
    loadingText: 'Načítavam položky...',
  },
  dataTable: {
    itemsPerPageText: 'Počet riadkov na stránku:',
    ariaLabel: {
      sortDescending: 'Zoradené zostupne.',
      sortAscending: 'Zoradené vzostupne.',
      sortNone: 'Nezoradené.',
      activateNone: 'Aktivujte na zrušenie zoradenia.',
      activateDescending: 'Aktivujte na zoradenie zostupne.',
      activateAscending: 'Aktivujte na zoradenie vzostupne.',
    },
    sortBy: 'Zoradiť podľa',
  },
  dataFooter: {
    itemsPerPageText: 'Počet položiek na stránku:',
    itemsPerPageAll: 'Všetko',
    nextPage: 'Ďalšia stránka',
    prevPage: 'Predchádzajúca stránka',
    firstPage: 'Prvá stránka',
    lastPage: 'Posledná stránka',
    pageText: '{0}–{1} z {2}',
  },
  dateRangeInput: {
    divider: 'až',
  },
  datePicker: {
    itemsSelected: '{0} vybraných',
    range: {
      title: 'Vyberte rozsah dátumov',
      header: 'Zadajte rozsah dátumov',
    },
    title: 'Vyberte dátum',
    header: 'Zadajte dátum',
    input: {
      placeholder: 'Zadajte dátum',
    },
    ariaLabel: {
      previousMonth: 'Predchádzajúci mesiac',
      nextMonth: 'Ďalší mesiac',
      selectYear: 'Vyberte rok',
      selectDate: '{0}',
      currentDate: 'Dnes, {0}',
    },
  },
  noDataText: 'Nie sú dostupné žiadne dáta',
  carousel: {
    prev: 'Predchádzajúci obrázok',
    next: 'Další obrázok',
    ariaLabel: {
      delimiter: 'Snímka {0} z {1}',
    },
  },
  calendar: {
    moreEvents: '{0} ďalších',
    today: 'Dnes',
  },
  input: {
    clear: 'Vymazať {0}',
    prependAction: 'Akcia pred {0}',
    appendAction: 'Akcia za {0}',
    otp: 'Prosím zadajte OTP znak {0}',
  },
  fileInput: {
    counter: '{0} súborov',
    counterSize: '{0} súborov ({1} celkom)',
  },
  fileUpload: {
    title: 'Sem presuňte súbory',
    divider: 'alebo',
    browse: 'Prehliadať súbory',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Vyberte čas',
  },
  pagination: {
    ariaLabel: {
      root: 'Navigácia stránkovania',
      next: 'Ďalšia stránka',
      previous: 'Predchádzajúca stránka',
      page: 'Ísť na stránku {0}',
      currentPage: 'Aktuálna stránka, stránka {0}',
      first: 'Prvá stránka',
      last: 'Posledná stránka',
    },
  },
  stepper: {
    next: 'Ďalší',
    prev: 'Predchádzajúci',
  },
  rating: {
    ariaLabel: {
      item: 'Hodnotenie {0} z {1}',
    },
  },
  loading: 'Načítavam...',
  infiniteScroll: {
    loadMore: 'Načítať viac',
    empty: 'Žiadne ďalšie',
  },
  rules: {
    required: 'Toto pole je povinné',
    email: 'Zadajte platnú e-mailovú adresu',
    number: 'Toto pole môže obsahovať iba čísla',
    integer: 'Toto pole môže obsahovať iba celé čísla',
    capital: 'Toto pole môže obsahovať iba veľké písmená',
    maxLength: 'Musíte zadať maximálne {0} znakov',
    minLength: 'Musíte zadať minimálne {0} znakov',
    strictLength: 'Dĺžka zadaného poľa je neplatná',
    exclude: 'Znak {0} nie je povolený',
    notEmpty: 'Vyberte aspoň jednu hodnotu',
    pattern: 'Neplatný formát',
  },
  hotkey: {
    then: 'potom',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'Šípka hore',
    downArrow: 'Šípka dole',
    leftArrow: 'Šípka vľavo',
    rightArrow: 'Šípka vpravo',
    backspace: 'Backspace',
    space: 'Medzera',
    plus: 'plus',
    shortcut: 'Klávesová skratka: {0}',
  },
  video: {
    play: 'Prehrať',
    pause: 'Pozastaviť',
    seek: 'Vyhľadať',
    volume: 'Hlasitosť',
    showVolume: 'Zobraziť ovládanie hlasitosti',
    mute: 'Stlmiť',
    unmute: 'Zrušiť stlmenie',
    enterFullscreen: 'Celá obrazovka',
    exitFullscreen: 'Opustiť celú obrazovku',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'Vybrať farbu z obrazovky',
      hueSlider: 'Odtieň',
      alphaSlider: 'Alfa',
      redInput: 'Červená',
      greenInput: 'Zelená',
      blueInput: 'Modrá',
      alphaInput: 'Alfa',
      hueInput: 'Odtieň',
      saturationInput: 'Sýtosť',
      lightnessInput: 'Svetlosť',
      hexInput: 'HEX hodnota',
      hexaInput: 'HEX s alfa hodnotou',
      changeFormat: 'Zmeniť formát farby',
    },
  },
}
